<template>
    <div>
        <select class="form-control d-none" id="language-select" @change="switchLanguage">
            <option
                    v-for="language in languages"
                    :value="language.iso_code"
                    :selected="currentLanguage == language.id"
            >{{ language.local_title }}
            </option>
        </select>

        <div class="language-select custom-language-select" id="custom-language-select" v-click-outside="this.langSelectClose">
            <label for="custom-language-select" class="m-0" @click="langSelectOpen">{{this.getLanguageTitleById(this.currentLanguage)}} <i class="fas fa-angle-down"></i></label>
            <div class="options" style="display: none;">
                <div class="text-bubble-square" style="display: none"></div>
                <template v-for="(language, index) in languages">
                    <div class="option" :value="language.id"
                         :class="{ 'border-bottom': index !== languages.length-1 }"
                         @click="langSelectChangeValue(language.id, language.iso_code, language.local_title)">
                        {{language.local_title}}
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import language from "../store/Modules/language";

    export default {
        name: 'language-switcher',
        props: {
            switchUserLanguage: {
                type: Boolean,
                default: true,
            }
        },
        data() {
            return {
                iconDown: `<i class="fas fa-angle-down"></i>`,
            }
        },
        computed: {
            ...mapGetters('Language', ['currentLanguage', 'currentLanguageIso', 'languages']),
        },
        created() {
            this.$changeLanguage(this.currentLanguageIso);
            this.fetchLanguages();
        },
        methods: {
            ...mapActions('Language', ['fetchLanguages', 'setCurrentLanguageIso', 'setCurrentLanguage', 'resetState']),
            switchLanguage() {
                let iso_code = $('#language-select').val();
                let language_id = this.getLanguageIdFromIso(iso_code);
                if(language_id !== null) {
                    let params = new FormData;
                    params.set('selected_language_id', language_id);
                    if(this.switchUserLanguage) {
                        axios.post('/users/changeLanguage', params).then(response => {
                            this.changeClientLanguage(iso_code, language_id);
                        });
                    } else {
                        this.changeClientLanguage(iso_code, language_id);
                    }
                }
            },
            changeClientLanguage(iso, id) {
                let iso_lowercase = iso.toLowerCase();
                this.$changeLanguage(iso_lowercase);
                this.language = iso_lowercase;
                this.setCurrentLanguageIso(iso_lowercase);
                this.setCurrentLanguage(id);
                this.$vueEventBus.$emit('clear-errors', true);
            },
            getLanguageIdFromIso(iso_code) {
                if(Array.isArray(this.languages) && this.languages.length > 0) {
                    for(let i = 0; i < this.languages.length; i++) {
                        if(this.languages[i].iso_code === iso_code) {
                            return this.languages[i].id;
                        }
                    }
                }

                return null;
            },
            generateLanguageIsoFromId(id) {
                if(Array.isArray(this.languages) && this.languages.length > 0) {
                    for(let i = 0; i < this.languages.length; i++) {
                        if(Number(this.languages[i].id) === Number(id)) {
                            return this.languages[i].iso_code.toLowerCase();
                        }
                    }
                }

                return null;
            },
            getLanguageTitleById(id) {
                if(Array.isArray(this.languages) && this.languages.length > 0) {
                    for(let i = 0; i < this.languages.length; i++) {
                        if(Number(this.languages[i].id) === Number(id)) {
                            return this.languages[i].local_title.toLowerCase();
                        }
                    }
                }

                return null;
            },
            langSelectOpen(event) {
                let currentLanguage = this.currentLanguage;
                $('.custom-language-select .options').show();
                $('.custom-language-select').addClass("open");

                $('.custom-language-select .option').removeClass("selected");
                $('.custom-language-select .option').each(function () {
                    if (parseInt(this.getAttribute('value')) === parseInt(currentLanguage)) {
                        this.classList.add("selected");
                    }
                });
            },
            langSelectChangeValue(id, value, name) {
                this.langSelectClose();

                $('#language-select').val(value);
                $('#language-select').change();

                this.switchLanguage();
                $('.custom-language-select label').html(`${this.getLanguageTitleById(id)} ${this.iconDown}`);
            },
            langSelectClose () {
                $('.custom-language-select .options').hide();
                $('.custom-language-select').removeClass("open");
            }
        }
    }
</script>

<style lang="scss">
    .language-select {
        cursor: pointer;
        text-transform:uppercase;
        position: relative;

        -webkit-user-select: none; /* Safari */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* IE10+/Edge */
        user-select: none; /* Standard */
    }

    .language-select label i {
        margin-left: 0.2rem;
    }
    .language-select.open .options {
        display: flex;
        flex-direction: column;

        position: absolute;
        background-color: white;
        right: -0.4rem;
        border: #e1e1e1 1px solid;
        z-index: 1000;
        text-align: center;
    }

    .language-select .option {
        color: #515151;
        padding: 0.2rem 0.8rem;
    }
    .language-select .option.selected {
        color: #000000;
        font-weight: bold;
    }
</style>
